import { gettext } from '@eventbrite/i18n';
import { TagObject, Tags } from '@eventbrite/tags';
import React from 'react';
import { NearbyPOITagShape } from '../../../../types/AppProps';
import { ResponsiveSection } from '../ResponsiveSection';
import styles from './NearbyPOI.module.scss';

export interface NearbyPOIProps {
    pointOfInterestName: string;
    nearbyPointsOfInterest: Array<NearbyPOITagShape>;
}

export const NearbyPOI = (props: NearbyPOIProps) => {
    const { pointOfInterestName, nearbyPointsOfInterest } = props;
    const HEADER_TEXT = gettext(
        'Points of interest near the %(pointOfInterestName)s',
        {
            pointOfInterestName,
        },
    );

    const SHOULD_DISPLAY_NEARBY_POI = nearbyPointsOfInterest?.length > 0;

    let shelfTags;
    if (SHOULD_DISPLAY_NEARBY_POI) {
        shelfTags = nearbyPointsOfInterest.map(
            (poi) =>
                ({
                    displayText: poi.pointOfInterestName,
                    linkUrl: poi.linkUrl,
                } as TagObject),
        );
    }
    const tagConfig = {
        backgroundColor: 'white',
        tagColor: '#F8F7FA',
    };

    return shelfTags ? (
        <ResponsiveSection>
            <div className={styles.nearbyPOIContainer}>
                <h2>{HEADER_TEXT}</h2>
                <Tags tags={shelfTags} {...tagConfig} />
            </div>
        </ResponsiveSection>
    ) : null;
};
